import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import UserLayout from './layouts/UserLayout';
import Dashboard from './pages/Dashboard';
import DnsZones from './pages/dns/DnsZones';
import DnsRecords from './pages/dns/DnsRecords';
import DnsCidr from './pages/dns/DnsCidr';
import DnsCidrEntries from './pages/dns/DnsCidrEntries';
import DnsPlans from './pages/dns/DnsPlans';
import DnsAnalytics from './pages/dns/DnsAnalytics';
import DnsAuthorize from './pages/dns/DnsAuthorize';
import { Domains as CdnDomains, DomainWizard as CdnDomainWizard, Analytics as CdnAnalytics } from './pages/cdn';
import CdnPlans from './pages/cdn/CdnPlans';
import DomainDetail from './pages/cdn/DomainDetail';
import Overview from './pages/cdn/Overview';
import OriginSettings from './pages/cdn/OriginSettings';
import SslSettings from './pages/cdn/SslSettings';
import PageRules from './pages/cdn/PageRules';
import CacheSettings from './pages/cdn/CacheSettings';
import DomainSettings from './pages/cdn/DomainSettings';
import DomainPlan from './pages/cdn/DomainPlan';
import Firewall from './pages/cdn/Firewall';
import Optimization from './pages/cdn/Optimization';
import Network from './pages/cdn/Network';
import Traffic from './pages/cdn/Traffic';
import Workers from './pages/cdn/Workers';
import WorkerDetail from './pages/cdn/WorkerDetail';
import WorkerCreate from './pages/cdn/WorkerCreate';
import WorkerEditor from './pages/cdn/WorkerEditor';
import DomainWorker from './pages/cdn/DomainWorker';
import Diagnostics from './pages/cdn/Diagnostics';
import ErrorPages from './pages/cdn/ErrorPages';
import Settings from './pages/Settings';
import Transfers from './pages/transfer/Transfers';
import Provision from './pages/Provision';
import DomainSearch from './pages/domain-registration/DomainSearch';
import MyDomains from './pages/domain-registration/MyDomains';
import DomainTransfer from './pages/domain-registration/DomainTransfer';
import ContactTemplates from './pages/domain-registration/ContactTemplates';
import DomainRegistrationDetail from './pages/domain-registration/DomainDetail';
import Subscription from './pages/billing/Subscription';
import Invoices from './pages/billing/Invoices';
import InvoiceDetail from './pages/billing/InvoiceDetail';
import Balance from './pages/billing/Balance';
import Cart from './pages/billing/Cart';
import MyCoupons from './pages/billing/Coupons';
import Affiliate from './pages/billing/Affiliate';
import SslBrowse from './pages/ssl/Browse';
import CodeSigningBrowse from './pages/ssl/CodeSigningBrowse';
import MyCertificates from './pages/ssl/MyCertificates';
import SslOrderDetail from './pages/ssl/OrderDetail';
import CodeSigningOrderDetail from './pages/ssl/CodeSigningOrderDetail';
import SslTools from './pages/ssl/SslTools';
import { HostDetail } from './pages/host';
import { MyVhosts, VhostDetail } from '../shared/pages/host_shared';
import WordpressSites from './pages/wordpress/WordpressSites';
import { MyVms, MyVpc, MyEip, MySecurityGroup, VmDetail, PurchaseVm, MyPortForward, MySshKeys } from './pages/evm';
import { KataContainerList, KataContainerCreate, KataContainerDetail } from './pages/containers';
import { DedicatedList, DedicatedOrder, DedicatedDetail } from './pages/dedicated';
// 轻应用已下架:组件保留备恢复 import { MyServices as LightappMyServices, ServiceDetail as LightappServiceDetail, ServiceCreate as LightappServiceCreate } from './pages/lightapp';
import ComingSoon from './pages/ComingSoon';
import { DiskOverview, DiskOrgDetail } from './pages/disk';
import { S3Overview, S3BucketDetail, S3Keys, S3Usage } from './pages/s3';
import { AccessPage, AccessSso } from './pages/access';
import S3UploadPanel from './pages/s3/UploadPanel';
import { SitesList, SiteLayout, SiteOverview, SitePages, SiteDomains, SiteForms, SiteContent, SiteBookings, SiteMedia, SiteMarketing, SiteStaff, SiteGiftCards, SiteReviews, SiteInventory, SiteDraftOrders, SiteAbandoned, SiteSettings, SiteVersions, SiteProducts, SiteProductEdit, SiteProductsBulk, SiteAnalytics, SiteCollections, SiteCollectionEdit, SiteOrders, SiteOrderDetail, SiteReturns, SiteCustomers, SiteCustomerDetail, SiteDiscounts, SitePayments, SiteBlog, SitePostEdit, SiteComments, SiteBlogTerms, SiteBlogAuthors, SiteEditor } from './pages/sites';
import { SupportTickets, SupportNewTicket, SupportTicketDetail } from './pages/support';
import { Streams as TmStreams, StreamDetail as TmStreamDetail } from './pages/tm';
import { Domains as WebmailDomains, Users as WebmailUsers, Aliases as WebmailAliases, Plans as WebmailPlans } from './pages/webmail';
import LlmAccount from './pages/llm/Account';
import LlmTokens from './pages/llm/Tokens';
import LlmLogs from './pages/llm/Logs';
import LlmModels from './pages/llm/Models';
import LlmStats from './pages/llm/Stats';
import LlmPlayground from './pages/llm/Playground';
import LlmMjLogs from './pages/llm/MjLogs';
import LlmTaskLogs from './pages/llm/TaskLogs';
import LlmCheckin from './pages/llm/Checkin';
import LlmSubscription from './pages/llm/Subscription';
import { AuthProvider } from '../shared/contexts/AuthContext';
import PrivateRoute from '../shared/components/PrivateRoute';
import Login from '../shared/pages/Login';
import Register from '../shared/pages/Register';
import ResetPassword from '../shared/pages/ResetPassword';
import VerifyEmail from '../shared/pages/VerifyEmail';
import ForwardVerify from '../shared/pages/ForwardVerify';
import NotFound from '../shared/pages/NotFound';
import CaptchaModal from '../shared/components/CaptchaModal';

import { userPath } from '../shared/config/paths';

/** /host/containers/:id → /containers/legacy/:id */
const LegacyRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/containers/legacy/${id}`} replace />;
};

const UserRoutes = () => (
    <UserLayout>
        <S3UploadPanel />
        <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="provision" element={<Navigate to="/dashboard" replace />} />
            <Route path="provision/:productType" element={<Provision />} />
            <Route path="dashboard" element={<Dashboard />} />
                    <Route path="dns">
                        <Route index element={<Navigate to="zones" replace />} />
                        <Route path="zones" element={<DnsZones />} />
                        <Route path="records/:zoneId" element={<DnsRecords />} />
                        <Route path="cidr" element={<DnsCidr />} />
                        <Route path="cidr/:cidrId" element={<DnsCidrEntries />} />
                        <Route path="plans" element={<DnsPlans />} />
                        <Route path="analytics" element={<DnsAnalytics />} />
                        <Route path="authorize" element={<DnsAuthorize />} />
                    </Route>
                    <Route path="cdn">
                        <Route index element={<Navigate to="domains" replace />} />
                        <Route path="domains" element={<CdnDomains />} />
                        <Route path="domains/new" element={<CdnDomainWizard />} />
                        <Route path="domains/:domainName" element={<DomainDetail />}>
                            <Route index element={<Overview />} />
                            <Route path="origin" element={<OriginSettings />} />
                            <Route path="ssl" element={<SslSettings />} />
                            <Route path="firewall" element={<Firewall />} />
                            <Route path="rules" element={<PageRules />} />
                            <Route path="cache" element={<CacheSettings />} />
                            <Route path="optimization" element={<Optimization />} />
                            <Route path="network" element={<Network />} />
                            <Route path="traffic" element={<Traffic />} />
                            <Route path="worker" element={<DomainWorker />} />
                            <Route path="plan" element={<DomainPlan />} />
                            <Route path="settings" element={<DomainSettings />} />
                            <Route path="diagnostics" element={<Diagnostics />} />
                            <Route path="error-pages" element={<ErrorPages />} />
                        </Route>
                        <Route path="workers" element={<Workers />} />
                        <Route path="workers/new" element={<WorkerCreate />} />
                        <Route path="workers/:workerId" element={<WorkerDetail />} />
                        <Route path="workers/:workerId/edit" element={<WorkerEditor />} />
                        <Route path="analytics" element={<CdnAnalytics />} />
                        <Route path="plans" element={<CdnPlans />} />
                    </Route>
                    <Route path="domain-registration">
                        <Route index element={<Navigate to="search" replace />} />
                        <Route path="search" element={<DomainSearch />} />
                        <Route path="transfer" element={<DomainTransfer />} />
                        <Route path="my-domains" element={<MyDomains />} />
                        <Route path="my-domains/:id" element={<DomainRegistrationDetail />} />
                        <Route path="contact-templates" element={<ContactTemplates />} />
                    </Route>
                    <Route path="ssl">
                        <Route index element={<Navigate to="browse" replace />} />
                        <Route path="browse" element={<SslBrowse />} />
                        <Route path="codesigning" element={<CodeSigningBrowse />} />
                        <Route path="certificates" element={<MyCertificates />} />
                        <Route path="order/:orderId" element={<SslOrderDetail />} />
                        <Route path="codesigning-order/:orderId" element={<CodeSigningOrderDetail />} />
                        <Route path="tools" element={<SslTools />} />
                    </Route>
                    <Route path="billing">
                        <Route index element={<Navigate to="balance" replace />} />
                        <Route path="balance" element={<Balance />} />
                        <Route path="subscription" element={<Subscription />} />
                        <Route path="invoices" element={<Invoices />} />
                        <Route path="invoices/:id" element={<InvoiceDetail />} />
                        <Route path="cart" element={<Cart />} />
                        <Route path="coupons" element={<MyCoupons />} />
                        <Route path="affiliate" element={<Affiliate />} />
                    </Route>
                    {/* 应用容器 已并入 独享容器：旧地址跳转 */}
                    <Route path="host">
                        <Route index element={<Navigate to="/containers" replace />} />
                        <Route path="containers" element={<Navigate to="/containers" replace />} />
                        <Route path="containers/:id" element={<LegacyRedirect />} />
                    </Route>
                    <Route path="dedicated">
                        <Route index element={<DedicatedList />} />
                        <Route path="order" element={<DedicatedOrder />} />
                        <Route path=":id" element={<DedicatedDetail />} />
                    </Route>
                    <Route path="containers">
                        <Route index element={<KataContainerList />} />
                        <Route path="legacy/:id" element={<HostDetail />} />
                        <Route path="create" element={<KataContainerCreate />} />
                        <Route path=":id" element={<KataContainerDetail />} />
                    </Route>
                    <Route path="host_shared">
                        <Route index element={<Navigate to="vhosts" replace />} />
                        <Route path="vhosts" element={<MyVhosts />} />
                        <Route path="vhosts/:id" element={<VhostDetail />} />
                        <Route path="wordpress" element={<WordpressSites />} />
                    </Route>
                    <Route path="evm">
                        <Route index element={<Navigate to="vms" replace />} />
                        <Route path="vms" element={<MyVms />} />
                        <Route path="vms/purchase" element={<PurchaseVm />} />
                        <Route path="vds" element={<PurchaseVm kind="vds" />} />
                        <Route path="vms/:id" element={<VmDetail />} />
                        <Route path="vpc" element={<MyVpc />} />
                        <Route path="eip" element={<MyEip />} />
                        <Route path="security-groups" element={<MySecurityGroup />} />
                        <Route path="port-forward" element={<MyPortForward />} />
                        <Route path="ssh-keys" element={<MySshKeys />} />
                    </Route>
                    {/* 轻应用已下架（2026-10）：路由统一占位，组件保留在 pages/lightapp 以便将来恢复。
                        存量皆为测试实例，无真实客户；API 侧 LightAppDelistedMiddleware 同步 410。 */}
                    <Route path="lightapp/*" element={<ComingSoon title="LightApps" description="LightApps has been discontinued." />} />
                    <Route path="tm">
                        <Route index element={<Navigate to="streams" replace />} />
                        <Route path="streams" element={<TmStreams />} />
                        <Route path="streams/:id" element={<TmStreamDetail />} />
                        <Route path="*" element={<Navigate to="streams" replace />} />
                    </Route>
                    <Route path="disk">
                        <Route index element={<DiskOverview />} />
                        <Route path="orgs/:id" element={<DiskOrgDetail />} />
                        <Route path="*" element={<Navigate to={userPath("/disk")} replace />} />
                    </Route>
                    <Route path="access">
                        <Route index element={<AccessPage product="access" />} />
                        <Route path="sso" element={<AccessSso />} />
                    </Route>
                    <Route path="verify" element={<AccessPage product="verify" />} />
                    <Route path="s3">
                        <Route index element={<S3Overview />} />
                        <Route path="buckets/:id" element={<S3BucketDetail />} />
                        <Route path="keys" element={<S3Keys />} />
                        <Route path="usage" element={<S3Usage />} />
                        <Route path="*" element={<Navigate to={userPath("/s3")} replace />} />
                    </Route>
                    <Route path="sites">
                        <Route index element={<SitesList />} />
                        <Route path=":id" element={<SiteLayout />}>
                            <Route index element={<SiteOverview />} />
                            <Route path="analytics" element={<SiteAnalytics />} />
                            <Route path="pages" element={<SitePages />} />
                            <Route path="products" element={<SiteProducts />} />
                            <Route path="products/new" element={<SiteProductEdit />} />
                            <Route path="products/bulk" element={<SiteProductsBulk />} />
                            <Route path="products/:pid" element={<SiteProductEdit />} />
                            <Route path="collections" element={<SiteCollections />} />
                            <Route path="collections/new" element={<SiteCollectionEdit />} />
                            <Route path="collections/:cid" element={<SiteCollectionEdit />} />
                            <Route path="orders" element={<SiteOrders />} />
                            <Route path="orders/:oid" element={<SiteOrderDetail />} />
                            <Route path="returns" element={<SiteReturns />} />
                            <Route path="customers" element={<SiteCustomers />} />
                            <Route path="customers/:cid" element={<SiteCustomerDetail />} />
                            <Route path="discounts" element={<SiteDiscounts />} />
                            <Route path="payments" element={<SitePayments />} />
                            <Route path="blog" element={<SiteBlog />} />
                            <Route path="blog/:postId" element={<SitePostEdit />} />
                            <Route path="comments" element={<SiteComments />} />
                            <Route path="blog-terms" element={<SiteBlogTerms />} />
                            <Route path="blog-authors" element={<SiteBlogAuthors />} />
                            <Route path="forms" element={<SiteForms />} />
                            <Route path="collections-cms" element={<SiteContent />} />
                            <Route path="bookings" element={<SiteBookings />} />
                            <Route path="media" element={<SiteMedia />} />
                            <Route path="marketing" element={<SiteMarketing />} />
                            <Route path="marketing/:tab" element={<SiteMarketing />} />
                            <Route path="staff" element={<SiteStaff />} />
                            <Route path="gift-cards" element={<SiteGiftCards />} />
                            <Route path="reviews" element={<SiteReviews />} />
                            <Route path="inventory" element={<SiteInventory />} />
                            <Route path="draft-orders" element={<SiteDraftOrders />} />
                            <Route path="abandoned" element={<SiteAbandoned />} />
                            <Route path="domains" element={<SiteDomains />} />
                            <Route path="settings" element={<SiteSettings />} />
                            <Route path="settings/:tab" element={<SiteSettings />} />
                            <Route path="versions" element={<SiteVersions />} />
                            <Route path="*" element={<SiteOverview />} />
                        </Route>
                    </Route>
                    <Route path="webmail">
                        <Route index element={<Navigate to="domains" replace />} />
                        <Route path="domains" element={<WebmailDomains />} />
                        <Route path="users" element={<WebmailUsers />} />
                        <Route path="aliases" element={<WebmailAliases />} />
                        <Route path="plans" element={<WebmailPlans />} />
                    </Route>
                    <Route path="llm">
                        <Route index element={<Navigate to="account" replace />} />
                        <Route path="account" element={<LlmAccount />} />
                        <Route path="tokens" element={<LlmTokens />} />
                        <Route path="logs" element={<LlmLogs />} />
                        <Route path="models" element={<LlmModels />} />
                        <Route path="stats" element={<LlmStats />} />
                        <Route path="playground" element={<LlmPlayground />} />
                        <Route path="mj-logs" element={<LlmMjLogs />} />
                        <Route path="task-logs" element={<LlmTaskLogs />} />
                        <Route path="checkin" element={<LlmCheckin />} />
                        <Route path="subscription" element={<LlmSubscription />} />
                    </Route>
                    <Route path="support">
                        <Route index element={<Navigate to="tickets" replace />} />
                        <Route path="tickets" element={<SupportTickets />} />
                        <Route path="tickets/new" element={<SupportNewTicket />} />
                        <Route path="tickets/:id" element={<SupportTicketDetail />} />
                    </Route>
                    <Route path="settings" element={<Settings />} />
                    <Route path="transfers" element={<Transfers />} />
                    {/* In-app 404: show NotFound instead of silently redirecting,
                        so the user understands why they're not where they expected. */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
    </UserLayout>
);

const UserApp = () => {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/forward-verify" element={<ForwardVerify />} />
                {/* Site Builder editor: full screen, outside the console layout */}
                <Route path="/sites/:id/editor/:pageId?" element={
                    <PrivateRoute allowedRoles={['user', 'admin']}>
                        <SiteEditor />
                    </PrivateRoute>
                } />
                <Route path="/*" element={
                    <PrivateRoute allowedRoles={['user', 'admin']}>
                        <UserRoutes />
                    </PrivateRoute>
                } />
            </Routes>
            <CaptchaModal />
        </AuthProvider>
    );
};

export default UserApp;
